module.exports = __webpack_public_path__ + "static/media/email.32a64b3b.svg";